import React from "react";

interface ChartSkeletonProps {
  height?: number;
  showHeader?: boolean;
  headerTitle?: string;
  headerIcon?: string;
}

const ChartSkeleton: React.FC<ChartSkeletonProps> = ({
  height = 350,
  showHeader = true,
  headerTitle,
  headerIcon,
}) => {
  React.useEffect(() => {
    const styleId = "chart-skeleton-animation";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
        .skeleton-shimmer {
          background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={styles.chartCard}>
      {showHeader && (
        <div style={styles.chartHeader}>
          <div style={styles.chartHeaderContent}>
            <h3 style={styles.chartTitle}>
              {headerIcon && (
                <i className={headerIcon} style={styles.chartTitleIcon}></i>
              )}
              <div
                className="skeleton-shimmer"
                style={{
                  ...styles.skeletonText,
                  width: headerTitle ? "auto" : "200px",
                }}
              ></div>
            </h3>
          </div>
        </div>
      )}
      <div style={{ ...styles.chartBody, minHeight: `${height}px` }}>
        <div style={styles.skeletonContainer}>
          <div className="skeleton-shimmer" style={styles.skeletonChart}></div>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  chartCard: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    flex: 1,
  },
  chartHeader: {
    background: "linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)",
    padding: "20px 28px",
    borderBottom: "1px solid #e5e7eb",
  },
  chartHeaderContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },
  chartTitle: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
    color: "#2d3748",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
  },
  chartTitleIcon: {
    fontSize: "20px",
    color: "#667eea",
  },
  chartBody: {
    padding: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  skeletonContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  skeletonChart: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  },
  skeletonText: {
    height: "20px",
    borderRadius: "4px",
  },
};

export default ChartSkeleton;

